import {
  ServiceRequestFormContextValue,
  useServiceRequestFormContext,
} from 'src/components/ServiceRequestForm/CustomHooks/ServiceRequestFormContext';
import { ServiceRequestFormStep } from 'src/components/ServiceRequestForm/CustomHooks/serviceRequestFormSteps';

export interface UseServiceRequestFormFaqsOrchestratorReturn {
  faq: any;
  onNotResolved: () => void;
  onBack: () => void;
  onExit: () => void;
}

export const useServiceRequestFormFaqsOrchestrator =
  (): UseServiceRequestFormFaqsOrchestratorReturn => {
    const {
      formData,
      goPrev,
      goToStep,
      onExit,
    }: ServiceRequestFormContextValue = useServiceRequestFormContext();

    const faq: any = formData.category;

    const onNotResolved = (): void => {
      goToStep(ServiceRequestFormStep.Details);
    };

    const onBack = (): void => {
      goPrev();
    };

    return {
      faq,
      onNotResolved,
      onBack,
      onExit,
    };
  };